import React from 'react'
import { NavLink } from 'react-router-dom'
import { HiHome } from "react-icons/hi";
import { MdDashboard } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaRegMessage } from "react-icons/fa6";
import { FaSliders } from "react-icons/fa6";
import { FaRobot } from "react-icons/fa";
import { BiSolidBarChartAlt2 } from "react-icons/bi";
import { IoMenu } from "react-icons/io5";

import { useState } from 'react';





function Sidebar() {

    const [open, setOpen] = useState(false);
    return (
        <>
            <div className='min-h-screen sm:fixed  top-[70px] left-0 hidden sm:block w-[80px] dark:bg-[#121519] overflow-hidden '>
                <div
                    className={`w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff] opacity-60 cursor-not-allowed`}
                >
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <HiHome className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> 
                        <span className='text-[12px] font-bold dark:text-[#fff]'>Home</span>
                    </div>
                </div>
           
                <NavLink to="/dashboard"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <MdDashboard className='text-[20px] text-[#121519d1] dark:text-[#fff] ' /> <span className='text-[12px] font-bold'>Dashboard</span>
                    </div>
                </NavLink>
                <NavLink to="/agents"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <FaUsers className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Agents</span>
                    </div>
                </NavLink>
                <NavLink to="/"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-full flex flex-col items-center justify-center p-2'>
                        <FaRegMessage className='text-[20px] text-[#121519d1] dark:text-[#fff] mb-1' /> 
                        <span className='text-[12px] font-bold text-center w-full'>Send WhatsApp</span>
                    </div>
               
                </NavLink>
                <NavLink to="/Configuration"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <FaSliders className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Utility</span>
                    </div>
                </NavLink>
                <NavLink to="/Automation"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <FaRobot className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Automation</span>
                    </div>
                </NavLink>
                <NavLink to="/Report"
                    className={({ isActive }) =>
                        `w-full flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                            ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                            : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                    }>
                    <div className='w-[100%] flex flex-col items-center   p-2'>
                        <BiSolidBarChartAlt2 className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Report</span>
                    </div>
                </NavLink>
                <NavLink
                        onClick={() => {
                            setOpen(!open)
                        }}
                        to="/developer/console"
                        className={({ isActive }) =>
                            ` flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <BiSolidBarChartAlt2 className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>API</span>
                        </div>
                    </NavLink>
            </div>
            <div className={`min-h-screen   sm:hidden fixed top-0 right-0 z-40 bg-[#e9eef5]   overflow-hidden  w-[100%] dark:bg-[#121519] flex flex-col  justify-between  transform transition-transform duration-300 ease-in-out
        ${open ? "translate-x-0" : "-translate-x-full"} `} >
                <div className='w-[100%] flex flex-wrap h-[400px] '>
                    <NavLink to="/ProductsHome"
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff] "
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <HiHome className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold dark:text-[#fff]'>Home</span>
                        </div>
                    </NavLink>
                    <NavLink to="/"
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <MdDashboard className='text-[20px] text-[#121519d1] dark:text-[#fff] ' /> <span className='text-[12px] font-bold'>Dashboard</span>
                        </div>
                    </NavLink>
                    <NavLink to="/agents"
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <FaUsers className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Agents</span>
                        </div>
                    </NavLink>
                    <NavLink to="/WAMessage/WASendMessage/Index"
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <FaRegMessage className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Campaign</span>
                        </div>
                    </NavLink>
                    <NavLink to="/Configuration"
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <FaSliders className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Config</span>
                        </div>
                    </NavLink>
                    <NavLink to="/Automation"
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <FaRobot className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Automation</span>
                        </div>
                    </NavLink>
                    <NavLink
                        onClick={() => {
                            setOpen(!open)
                        }}
                        to="/Report"
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <BiSolidBarChartAlt2 className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>Report</span>
                        </div>
                    </NavLink>
                    <NavLink
                        onClick={() => {
                            setOpen(!open)
                        }}
                        to="/developer/console"
                        className={({ isActive }) =>
                            `w-[33%] h-[100px] flex flex-col items-center p-2 rounded-[5px] border-r-[4px] 
      ${isActive
                                ? "border-r-[rgb(27,117,202)] bg-[#aec5d8ba] dark:bg-[#2f3031] dark:text-[#fff]"
                                : "border-r-transparent bg-[#edf0f1ba] dark:bg-[#2c2c2c] dark:text-[#fff]"}`
                        }>
                        <div className='w-[100%] flex flex-col items-center   p-2'>
                            <BiSolidBarChartAlt2 className='text-[20px] text-[#121519d1] dark:text-[#fff]' /> <span className='text-[12px] font-bold'>API</span>
                        </div>
                    </NavLink>
           
                </div>
            </div>
            <button
                onClick={() => {
                    setOpen(!open)
                }}
                className='bg-[#ed7b004]  fixed bottom-0 py-2 z-50 w-[100%] sm:hidden text-[#fff] flex justify-center items-center text-[18px]'>
                <IoMenu />
                Account Menu</button>
        </>
    )
}

export default Sidebar
